<template>
    <div class="work">
        <div class="title_wrap">
            <span class="title_name">我的作品</span>
        </div>
        <div class="notification" v-if="works.length == 0" >
            <span> 未上传作品 </span>
        </div>
        <div v-else>
            <ul class="categorywork clearfix">
                <li v-for="(item,index) in works" :key="index" :class="{'noright':index%4==3}">
                    <img @click="goDetail(item.id)" :src="url +'/assets/upload/'+ item.cover" alt="未上传封面">
                    <span class="title">{{item.name}}</span>
                    <div class="categorycon">
                        <div v-if="item.coworker != ''" class="">
                            <span class="label">合作者：</span>
                            <span class="area">{{item.coworker}}</span>
                        </div>
                        <div class="">
                            <span class="label">指导老师：</span>
                            <span class="area">{{item.teacher}}</span>
                        </div>
                        <div class="">
                            <span class="label">年 级：</span>
                            <span class="area">{{convertGrade(item.gid)}}</span>
                        </div>
                   </div>
                </li>
            </ul>
            <el-pagination
               style="width:40%;float:right;margin-top:20px;margin-bottom:20px;margin-right:100px;"
               @size-change="handleSizeChange"
               @current-change="handleCurrentChange"
               :current-page="parseInt(page)"
               :page-sizes="[20, 30, 50]"
               :page-size="parseInt(rows)"
               layout="total, sizes, prev, pager, next, jumper"
               :total="parseInt(count)"
               class="table-page">
            </el-pagination>
        </div>

    </div>
</template>

<script>
import axios from 'axios'

export default {
  data () {
    return {
      token: '',
      url: this.API,
      pid: '0',
      page: '1',
      rows: '20',
      works: [],
      count: 0
    }
  },
  computed: {
  },
  created () {
  },
  mounted () {
    this._getData()
  },
  filters: {
  },
  methods: {
    _getData: function () {
      let _t = this
      _t.token = _t.$ls.get('token')
      axios.post(_t.API + '/api/work/mylist/', {token: _t.token, pid: _t.pid, page: _t.page, rows: _t.rows})
        .then(function (resp) {
          if (resp.data.code === '401') {
            _t.$router.push('/login/')
            return
          }
          if (resp.data.code === '0') {
            _t.works = resp.data.data
            _t.count = resp.data.data.length
          } else {
            _t.$messagewarning(resp.data.msg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    handleSizeChange (val) {
      this.rows = val
      this.page = 1 // size change, 回到第一页
      this._getData()
    },
    handleCurrentChange (val) {
      this.page = val
      this._getData()
    },
    goDetail (val) {
      this.$router.push(`/workdetail/${val}`)
    },
    convertGrade (val) {
      let grades = ['一年级', '二年级', '三年级', '赛道二']
      return grades[parseInt(val) - 1];
    }
  }
}
</script>

<style scoped lang='stylus'>
@import '~@/common/stylus/index'

.work{
  margin:0 auto;
  font-size:18px;
  padding: 50px calc((100% - 1024px) / 2);
}
.title_wrap{
    border-bottom: 1px solid #a3a3a3;
    margin-bottom: 5px;
    text-align: left;
    position: relative;
}
.title_name{
    font-family: sy;
    border-bottom: 4px solid $color-dark-blue;
    color: black;
    font-weight:600;
    font-size: 20px;
}
.header {
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid #e5e5e5;
  clear: both;
  position: relative;
  padding: 30px;
  font-family: PingFangSC-Medium;
  width: 100%;
}
.header-title {
  font-size: 20px;
  color: #333333;
  position: absolute;
  left: 10px;
  bottom: 0;
}
.header .header-upload {
  font-size: 24px;
  letter-spacing: 0;
  text-align: center;
  position: absolute;
  bottom: 0;
  right: 10px;
}
.work-action {
  text-align: center;
  display: flex;
  flex-direction: row;
  margin-top: 200px;
  margin-bottom: 200px;
}
.action-delete {
  background: #327EF9;
  border-radius: 4px;
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #F2F2F2;
  letter-spacing: 0;
  text-align: center;
  position: absolute;
  left: 45%;
  width: 200px;
  height: 30px;
}
.action-more {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #34495E;
  letter-spacing: 0;
  position: relative;
  left: 90%;
  margin-top: 8px;
}
.work-no {
  font-size: 29px;
  color: #999999;
  letter-spacing: 0;
  text-align: center;
  margin-top: 150px;
  margin-bottom: 550px;
}
.work-row {
  padding: 14px 0;
  overflow: hidden;
  clear: both;
  margin-bottom: 30px;
  display: flex;
  flex-direction: column;
  margin-bottom: 300px;
}
.row {
  display: flex;
  flex-direction: row;
  position: relative;
  left: 10px;
  margin-bottom: 20px;
  margin-top: 20px;
}
.data {
  font-family: PingFangSC-Regular;
  font-size: 15px;
  color: #34495E;
  letter-spacing: 0;
  text-align: left;
  width: 100%;
}
.data-img {
  max-width: 400px;
  max-height: 300px;
}
.current{
    background: $color-dark-blue;
}
.noright{
    margin-right: 0px !important;
}
.clearfix:after{
  content:"";
  display: table;
  clear:both;
}
.clearfix{
  *zoom: 1;
}
.mywork{
    height:60px;
    background: black;
    color: white;
    font-family: sybold;
    font-size: 30px;
    text-align: center;
    line-height: 60px;
    margin-bottom: 40px;
    border-radius:4px;
    margin-top:40px;
}
.allwork{
    text-align: center;
    font-family: sylight;
    font-size: 17px;
    color:black;
}
.categoryevery{
    margin-top:60px !important;
    width: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: center;
}
.categoryevery li{
    float: left;
    min-width: 135px;
    height: 40px;
    border-radius: 2px;
    text-align: center;
    line-height: 40px;
    font-size: 14px;
    color: black;
    background-color: #f6f9fc;
    margin-left: 10px;
    border-radius: 2px;
}
.categoryevery li:nth-child(1){
    margin-left: 0px;
}
.categoryevery .active{
    background: $color-dark-blue;
    color: white;
}
.categorywork{
    margin: 0 auto;
    margin-top: 60px;
    min-height: 500px;
}
.categorywork li{
    position: relative;
    float: left;
    width: 232px;
    margin-right: 26px;
    height: 320px;
    margin-bottom: 10px;
    background-color: #f6f9fc;
}
.categorywork img{
    display: block;
    width:100%;
    height: 174px;
    background: #f2f6fa;
    text-align: center;
}

.title{
    margin: 5px;
    font-family: sybold;
    font-size: 17px;
}
.notification {
    text-align: center;
    margin-top: 100px;
	font-size: 14px;
}
.categorycon{
    font-family: sy;
    font-size: 13px;
    padding: 10px;
}
.categorycon .label{
    font-size: 12px;
    width: 60px;
    display: inline-block;
    color: #999;
}
.categorycon .area{
  word-break: break-all;
  text-overflow: ellipsis;
  overflow: hidden;
  display: inline;
}
.categorycon .area-major{
  word-break: break-all;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
</style>



// WEBPACK FOOTER //
// Work.vue?ef70e332